const apiUrls = require('../../constants/apiUrls');

const closeCodes = {
    key: 'closeCodes',
    method: 'GET',
    getApiUrl: (request) => {
        return `${apiUrls.CLOSE_CODES_URL}/${request.serviceTypeId}/${request.signalAccessCode}`;
    },
    dependencies: [
        {
            key: 'schedulingSystemDetails',
            requestProps: [
                {
                    path: [
                        'details', 'serviceOrderInfoV2', 'serviceTypeId'
                    ],
                    propName: 'serviceTypeId'
                }
            ]
        },
        {
            key: 'customerDetails',
            requestProps: [
                {
                    path: [
                        'details', 'signalAccessCode'
                    ],
                    propName: 'signalAccessCode'
                }
            ]
        },
    ]
};

export default closeCodes;


// WEBPACK FOOTER //
// ./src/store/order-details-config/closeCodes.js